/* AI visualizer on the product page (snippet wheel-visualizer-product). Settings: window.WU_WVP. */
(function () {
  var C = window.WU_WVP || {}, T = C.t || {};
  var root = document.getElementById(C.id);
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  // the theme's Custom liquid block wraps content in .rte (its typography would break the dialog) – move the visualizer out of the wrapper
  var wvRte = root.parentElement && root.parentElement.closest('.rte');
  if (wvRte) wvRte.parentNode.insertBefore(root, wvRte.nextSibling);

  var dialog = root.querySelector('.wvp__dialog');
  var $ = function (s) { return dialog.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(dialog.querySelectorAll(s)); };
  var TOKEN = root.dataset.token;
  var state = { screen: 'login', mode: 'photo', spec: null, car: null, ratio: null, credits: 0, cost: 10, busy: false, resultUrl: null, qty: parseInt(root.dataset.defaultQty, 10) || 4, loaded: false, other: null, timers: [], ex: 0 };

  // ---------- tracking (Shopify Customer events -> pixel -> GA4 + Worker) ----------
  var vtrackSent = {};
  function track(name, data, once) {
    try {
      if (once) { if (vtrackSent[name]) return; vtrackSent[name] = 1; }
      var d = {
        product_id: root.dataset.productId, product: root.dataset.title,
        variant_id: typeof currentVariantId === 'function' && root.dataset.token ? currentVariantId() : root.dataset.defaultVariant,
        logged_in: root.dataset.loggedIn === '1', customer_id: root.dataset.customerId || null,
        screen: state.screen, ab: root.dataset.ab || 'A'

      };
      for (var k in (data || {})) d[k] = data[k];
      var tries = 0;
      (function send() {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var p = Shopify.analytics.publish('wheelsup:viz_' + name, d);
          if (p && p.catch) p.catch(function () {});
        } else if (tries++ < 20) setTimeout(send, 500); // Shopify analytics may load after the script
      })();
    } catch (e) {}
  }

  // ---------- obrazovky ----------
  var STEP = { login: 0, start: 0, selected: 0, empty: 0, generating: 1, result: 2 };
  function show(screen) {
    state.screen = screen;
    $$('[data-screens]').forEach(function (el) { el.hidden = el.dataset.screens.split(' ').indexOf(screen) === -1; });
    var idx = STEP[screen];
    $$('.wvp__steps li').forEach(function (li) {
      var i = Array.prototype.indexOf.call(li.parentNode.children, li);
      var done = i < idx || (screen === 'selected' && i === 0) || screen === 'result';
      li.classList.toggle('is-done', done);
      li.classList.toggle('is-active', !done && i === idx);
      li.querySelector('.wvp__dot').textContent = done ? '✓' : String(i + 1);
    });
    exitFull();
    var body = $('.wvp__body'); if (body) body.scrollTop = 0;
    if (screen === 'login' || screen === 'start' || screen === 'empty') showExample(state.ex);
    if (screen === 'empty') track('credits_empty', { credits: state.credits });
  }
  function openDialog(source) {
    track('open', { source: typeof source === 'string' ? source : 'button' });
    if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
    if (window.__wvpOnOpen) window.__wvpOnOpen(); else show('login');
  }
  function closeDialog() { exitFull(); if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); }
  function exitFull() { var st = $('.wvp__stage'); if (st) st.classList.remove('is-full'); }

  root.querySelector('.wvp__open').addEventListener('click', function () { openDialog('button'); });
  // prompts outside the visualizer (section wu-viz-banner, block wu_viz_card): [data-wvp-open]
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-wvp-open]');
    if (!t) return;
    e.preventDefault();
    openDialog(t.getAttribute('data-wvp-open') || 'cta');
  });
  // floating button over the main product photo
  (function () {
    var scope = root.closest('.shopify-section, section') || document;
    if (root.dataset.ab === 'B') return; // A/B test: variant B = button under the cart button
    var gw = scope.querySelector('media-gallery.product__gallery, .product-gallery__carousel-wrapper');
    if (!gw || gw.querySelector('.wvp-trigger--overlay')) return;
    // main image (not under the thumbnails)
    var main = gw.querySelector('[id^="SliderGallery-"]');
    if (main && main.parentElement) gw = main.parentElement;
    // button on the photo: dark pill with a colored border, star + “Generate”, top right
    var ob = document.createElement('button');
    ob.type = 'button';
    ob.className = 'wvp-trigger--overlay' + (root.dataset.pos === 'bottom' ? ' wvp-trigger--bottom' : '');
    ob.setAttribute('aria-haspopup', 'dialog');
    ob.setAttribute('aria-label', T["wheelsup.viz.icon_alt"]);
    ob.title = T["wheelsup.viz.icon_alt"];
    ob.innerHTML = '<img class="wvp-gen__icon" src="' + C.icon + '" width="20" height="21" alt="" aria-hidden="true"><span class="wvp-gen__text"></span>';
    ob.querySelector('.wvp-gen__text').textContent = (C.label || T["wheelsup.viz.generate"]);
    ob.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openDialog('photo'); });
    gw.appendChild(ob);
    root.classList.add('has-overlay');
  })();
  $$('.wvp__close').forEach(function (b) { b.addEventListener('click', closeDialog); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDialog(); });
  dialog.addEventListener('cancel', function (e) {
    var st = $('.wvp__stage');
    if (st && st.classList.contains('is-full')) { e.preventDefault(); exitFull(); }
  });

  // ---------- examples (start screen) ----------
  var EXAMPLES = [];
  try { EXAMPLES = JSON.parse(root.querySelector('.wvp__examples').textContent); } catch (e) {}
  function relabel(cmp) {
    if (!cmp || !cmp.querySelector) return;
    var b = cmp.querySelector('.wvcmp__label--before'), a = cmp.querySelector('.wvcmp__label--after');
    if (b) b.textContent = T["wheelsup.viz.before_upper"]; if (a) a.textContent = T["wheelsup.viz.after_upper"];
  }
  function showExample(i) {
    var ex = EXAMPLES[i]; if (!ex) return;
    state.ex = i;
    var cmp = $('.wvp__examples-cmp');
    if (cmp && cmp.setImages) { cmp.setImages(ex.b, ex.a); relabel(cmp); }
    $$('.wvp__ex').forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
  }
  (function buildThumbs() {
    var list = $('.wvp__ex-list'); if (!list) return;
    EXAMPLES.forEach(function (ex, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'wvp__thumb wvp__ex'; b.setAttribute('aria-label', T["wheelsup.viz.example_short"] + ' ' + (i + 1));
      var img = document.createElement('img'); img.src = ex.a; img.alt = ''; img.loading = 'lazy'; img.width = 160; img.height = 110;
      b.appendChild(img);
      b.addEventListener('click', function () { showExample(i); track('example', { example: i + 1 }); });
      list.appendChild(b);
    });
  })();

  // automatic open after returning from login (?wv=1)
  if (/[?&]wv=1\b/.test(location.search)) {
    try { var u = new URL(location.href); u.searchParams.delete('wv'); history.replaceState(null, '', u.toString()); } catch (e) {}
    setTimeout(function () { openDialog('login_return'); }, 300);
  }

  Array.prototype.forEach.call(dialog.querySelectorAll('a[href*="customer_authentication/login"]'), function (a) {
    a.addEventListener('click', function () { track('login_click'); });
  });

  var API = (root.dataset.worker || '').replace(/\/+$/, '');
  var GUEST = root.dataset.guest === '1';
  var GATE = root.dataset.gate === '1';
  if (!TOKEN && !GUEST) return; // not logged in – only the start screen with login
  // not logged in with free visualizations: random browser ID (the server enforces the limit together with the IP)
  var GUEST_ID = '';
  if (GUEST) {
    try { GUEST_ID = localStorage.getItem('wv_gid') || ''; } catch (e) {}
    if (!/^[A-Za-z0-9-]{16,64}$/.test(GUEST_ID)) {
      GUEST_ID = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2));
      try { localStorage.setItem('wv_gid', GUEST_ID); } catch (e) {}
    }
  }

  var VARIANTS = {};
  try { VARIANTS = JSON.parse(root.querySelector('.wvp__variants').textContent); } catch (e) {}
  var FINISH_INDEX = parseInt(root.dataset.finishIndex, 10);
  var HAS_VIZ_IMG = root.dataset.hasVizImage === 'true';
  var CAR_KEY = 'wv_car_photo_v1';
  var HISTORY_KEY = 'wv_history_v1';
  var RATIOS = { '1:1': 1, '2:3': 2/3, '3:2': 1.5, '3:4': .75, '4:3': 4/3, '4:5': .8, '5:4': 1.25, '9:16': 9/16, '16:9': 16/9, '21:9': 21/9 };
  var GEN_TITLES = [T["wheelsup.viz.gen_title_1"], T["wheelsup.viz.gen_title_2"], T["wheelsup.viz.gen_title_3"]];

  // button text in the theme style (.button > .btn-text)
  function setLabel(el, text) { var t = el.querySelector('.btn-text') || el; t.textContent = text; }
  function abs(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  // chyba zůstane, dokud ji zákazník neodklikne nebo nezačne další akci (dřív zmizela po 7 s)
  function setError(msg) { var e = $('.wvp__error'); e.textContent = msg || ''; e.hidden = !msg; }
  $('.wvp__error') && $('.wvp__error').addEventListener('click', function () { this.hidden = true; });
  function toast(msg) {
    var t = $('.wvp__toast'); t.textContent = msg; t.hidden = false;
    clearTimeout(state.toastTimer); state.toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }
  var FREE_LEFT = T["wheelsup.viz.free_left"];
  function renderFree() {
    if (!GUEST || !state.limit) return;
    $$('.wvp__free').forEach(function (p) {
      var dots = p.querySelector('.wvp__free-dots'); dots.innerHTML = '';
      for (var i = 0; i < state.limit; i++) { var d = document.createElement('i'); if (i < state.credits) d.className = 'is-on'; dots.appendChild(d); }
      p.querySelector('.wvp__free-text').textContent = FREE_LEFT.replace('%left%', state.credits).replace('%limit%', state.limit);
      p.hidden = p.dataset.modePane ? p.dataset.modePane !== state.mode : false;
    });
  }
  function setCredits(n, cost) {
    state.credits = n;
    if (cost) state.cost = cost;
    renderFree();
    $$('.wvp__credits-count').forEach(function (el) { el.textContent = n; });
    $$('.wvp__credits').forEach(function (el) { el.classList.toggle('is-low', n < state.cost); });
    $$('.wvp__cost').forEach(function (el) { el.textContent = state.cost; });
  }
  function api(path, opts) {
    opts = opts || {};
    opts.headers = Object.assign(TOKEN ? { Authorization: 'Bearer ' + TOKEN } : { 'X-Guest-Id': GUEST_ID }, opts.headers || {});
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { d._status = r.status; return d; });
    });
  }
  function money(cents) {
    try { return new Intl.NumberFormat(C.locale, { style: 'currency', currency: root.dataset.currency || 'CZK', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return (cents / 100) + ' ' + (root.dataset.currency || 'CZK'); }
  }

  // currently selected variant
  function productForm() { return document.querySelector('form[action*="/cart/add"]:not([id*="installment"])'); }
  function currentVariantId() {
    var form = productForm();
    var input = form && form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : root.dataset.defaultVariant;
  }
  function currentSelection() {
    var id = currentVariantId();
    var v = VARIANTS[id] || VARIANTS[root.dataset.defaultVariant] || {};
    var finish = FINISH_INDEX >= 0 && v.options ? (v.options[FINISH_INDEX] || '') : '';
    var img = HAS_VIZ_IMG ? root.dataset.productImage : (v.img || root.dataset.productImage);
    return { id: id, image: abs(img), finish: finish, title: v.title || '', available: v.available !== false, price: v.price || 0 };
  }
  function renderVariant() {
    var sel = currentSelection();
    var t = $('.wvp__wheel-variant');
    if (!t) return;
    var vt = sel.title && sel.title !== 'Default Title' ? sel.title : '';
    t.textContent = vt; t.hidden = !vt;
  }
  function renderTotal() {
    $('.wvp__qty-value').textContent = state.qty;
    var sel = currentSelection();
    var add = $('.wvp__add');
    setLabel(add, sel.available ? T["wheelsup.viz.add_to_cart"] + ' · ' + money(sel.price * state.qty) : T["wheelsup.viz.sold_out"]);
    add.disabled = !sel.available;
  }

  function hasCredits() { return state.credits >= state.cost; }
  function home() {
    if (!hasCredits()) return show('empty');
    show(state.mode === 'car' || !state.car ? 'start' : 'selected');
  }
  // mode: own photo / car entered as text (AI creates the whole car)
  function setMode(m) {
    state.mode = m;
    root.classList.toggle('is-carmode', m === 'car');
    $$('.wvp__tab').forEach(function (t) { var on = t.dataset.mode === m; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
    $$('.wvp__pane--start [data-mode-pane]').forEach(function (el) { el.hidden = el.dataset.modePane !== m || (el.classList.contains('wvp__free') && !state.limit); });
    if (m === 'car') loadMakes();
  }
  $$('.wvp__tab').forEach(function (t) {
    t.addEventListener('click', function () { setMode(t.dataset.mode); track('mode', { mode: t.dataset.mode }); home(); });
  });
  $$('.wvp__to-car').forEach(function (b) { b.addEventListener('click', function () { setMode('car'); track('mode', { mode: 'car' }); home(); }); });
  var carForm = $('.wvp__carform');
  var ymmBase = (window.wuYmm && window.wuYmm.assetBase) || '';
  var ymmCache = {};
  function ymmJSON(name) {
    var u = ymmBase.replace('wu-ymm-znacky.json', name);
    return ymmCache[u] || (ymmCache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }));
  }
  function fillSelect(sel, items, keepFirst) {
    while (sel.options.length > (keepFirst ? 1 : 0)) sel.remove(sel.options.length - 1);
    items.forEach(function (it) { var o = document.createElement('option'); o.value = it[0]; o.textContent = it[1]; sel.appendChild(o); });
    sel.disabled = !items.length;
  }
  function genName(key) { return String(key).replace(/\s*\[[^\]]*\]\s*$/, '').trim(); }
  function loadMakes() {
    if (!carForm || carForm.dataset.loaded || !ymmBase) return;
    carForm.dataset.loaded = '1';
    ymmJSON('wu-ymm-znacky.json').then(function (brands) {
      fillSelect(carForm.make, brands.map(function (b) { return [b[1], b[0]]; }), true);
    }).catch(function () { carForm.dataset.loaded = ''; setError(T["wheelsup.viz.err_server"]); });
  }
  if (carForm) {
    carForm.make.addEventListener('change', function () {
      fillSelect(carForm.model, [], true); fillSelect(carForm.year, [], true);
      var slug = carForm.make.value; if (!slug) return;
      ymmJSON('wu-ymm-' + slug + '.json').then(function (data) {
        if (carForm.make.value !== slug) return;
        var keys = Object.keys(data).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
        fillSelect(carForm.model, keys.map(function (k) { return [k, k]; }), true);
      }).catch(function () {});
    });
    carForm.model.addEventListener('change', function () {
      var m = String(carForm.model.value).match(/\[(\d{4})\s*-\s*(\d{4})?\]/), years = [];
      if (m) { var to = Math.min(parseInt(m[2] || new Date().getFullYear(), 10), new Date().getFullYear() + 1); for (var y = to; y >= parseInt(m[1], 10); y--) years.push([String(y), String(y)]); }
      fillSelect(carForm.year, years, true);
    });
    carForm.addEventListener('change', function (e) { e.target.classList.remove('is-bad'); if (carForm.make.value && carForm.model.value) $('.wvp__car-err').hidden = true; });
    carForm.addEventListener('submit', function (e) { e.preventDefault(); goCar(); });
    $('.wvp__car-go').addEventListener('click', goCar);
  }
  function goCar() {
    var mk = carForm.make, md = carForm.model, ok = !!(mk.value && md.value);
    mk.classList.toggle('is-bad', !mk.value); md.classList.toggle('is-bad', !md.value);
    $('.wvp__car-err').hidden = ok;
    if (!ok) return;
    state.spec = { make: mk.options[mk.selectedIndex].textContent, model: genName(md.value), year: carForm.year.value, color: carForm.color.value.trim() };
    track('car_spec', { make: state.spec.make, model: state.spec.model, year: state.spec.year });
    generate();
  }
  function setCar(dataUrl, ratio, persist) {
    state.car = dataUrl; state.ratio = ratio;
    $('.wvp__car-img').src = dataUrl;
    var ri = $('.wvp__ready-img'); if (ri) ri.src = dataUrl;
    if (persist) { try { localStorage.setItem(CAR_KEY, JSON.stringify({ data: dataUrl, ratio: ratio, ts: Date.now() })); } catch (e) {} }
  }
  function ratioOf(w, h) {
    var r = w / h, best = '4:3', diff = 99;
    Object.keys(RATIOS).forEach(function (k) { var d = Math.abs(RATIOS[k] - r); if (d < diff) { diff = d; best = k; } });
    return best;
  }
  function shrink(src, max, quality) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        var s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        resolve({ data: c.toDataURL('image/jpeg', quality), w: c.width, h: c.height });
      };
      img.onerror = reject;
      img.src = src;
    });
  }


  window.__wvpOnOpen = function () {
    setError('');
    renderTotal(); renderVariant();
    if (state.loaded) { if (state.screen === 'login') home(); return; }
    state.loaded = true;
    try {
      var saved = JSON.parse(localStorage.getItem(CAR_KEY) || 'null');
      if (saved && saved.data && Date.now() - saved.ts < 30 * 864e5) setCar(saved.data, saved.ratio, false);
    } catch (e) {}
    show(state.car ? 'selected' : 'start');
    api(GUEST ? '/guest' : '/credits').then(function (d) {
      if (d._status === 401) { setError(T["wheelsup.viz.err_session"]); return; }
      if (GUEST) {
        if (typeof d.left !== 'number') { setError(T["wheelsup.viz.err_server"]); return; }
        state.limit = d.limit || 5;
        setCredits(d.left, 1);
      } else setCredits(d.credits || 0, d.cost);
      if (state.screen === 'start' || state.screen === 'selected') home();
    }).catch(function () { setError(T["wheelsup.viz.err_server"]); });
  };

  // photo selection
  function pickPhoto() { $('.wvp__file').value = ''; $('.wvp__file').click(); }
  $$('.wvp__pick').forEach(function (b) { b.addEventListener('click', pickPhoto); });
  $('.wvp__file').addEventListener('change', function (ev) { useFile(ev.target.files && ev.target.files[0]); });
  // drag & drop a photo onto the drop zone
  $$('.wvp__drop').forEach(function (z) {
    ['dragenter', 'dragover'].forEach(function (n) { z.addEventListener(n, function (e) { e.preventDefault(); z.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (n) { z.addEventListener(n, function (e) { e.preventDefault(); z.classList.remove('is-over'); }); });
    z.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (f) { track('photo_drop'); useFile(f); } });
  });
  function useFile(file) {
    if (!file) return;
    if (file.type && file.type.indexOf('image/') !== 0) { setError(T["wheelsup.viz.err_format"]); return; }
    setError('');
    var src = URL.createObjectURL(file);
    shrink(src, 1600, 0.88).then(function (r) {
      URL.revokeObjectURL(src);
      setCar(r.data, ratioOf(r.w, r.h), true);
      track('photo', { ratio: state.ratio, width: r.w, height: r.h });
      home();
    }).catch(function () { setError(T["wheelsup.viz.err_format"]); });
  }

  // generation
  function setGenStep(i) {
    $('.wvp__gen-title').textContent = GEN_TITLES[Math.min(i - 1, GEN_TITLES.length - 1)] || GEN_TITLES[0];
  }
  // e-mail before visualization (not logged in)
  var EMAIL_KEY = 'wv_email_v1';
  function savedEmail() { try { return JSON.parse(localStorage.getItem(EMAIL_KEY) || 'null'); } catch (e) { return null; } }
  var gate = $('.wvp__gate');
  if (gate) {
    var gateForm = gate.querySelector('form'), gateEmail = gate.querySelector('.wvp__gate-email'), gateErr = gate.querySelector('.wvp__gate-err');
    gate.addEventListener('click', function (e) { if (e.target === gate) gate.hidden = true; });
    gateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = gateEmail.value.trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      gateErr.hidden = ok; gateEmail.classList.toggle('is-bad', !ok);
      if (!ok) { gateEmail.focus(); return; }
      var consent = gate.querySelector('.wvp__gate-check').checked;
      try { localStorage.setItem(EMAIL_KEY, JSON.stringify({ e: v, c: consent, ts: Date.now() })); } catch (err) {}
      state.email = { e: v, c: consent };
      track('email_gate', { consent: consent });
      gate.hidden = true;
      generate();
    });
  }
  function generate() {
    var carMode = state.mode === 'car';
    if (state.busy || (carMode ? !state.spec : !state.car)) return;
    if (!hasCredits()) return show('empty');
    if (GATE && gate && !(state.email || (state.email = savedEmail()))) {
      gate.hidden = false;
      setTimeout(function () { gate.querySelector('.wvp__gate-email').focus(); }, 50);
      return;
    }
    var sel = currentSelection();
    state.busy = true; state.other = null; setError('');
    show('generating');
    var t0 = Date.now();
    track('generate_start', { credits: state.credits, cost: state.cost });
    setGenStep(1);
    state.timers.push(setTimeout(function () { setGenStep(2); }, 20000));
    state.timers.push(setTimeout(function () { setGenStep(3); }, 60000));

    api('/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ carImage: carMode ? undefined : state.car, carSpec: carMode ? state.spec : undefined, aspectRatio: carMode ? '16:9' : state.ratio, wheelImageUrl: sel.image, wheelTitle: root.dataset.title, finish: sel.finish, productId: root.dataset.productId || undefined, variantId: sel.id || undefined, email: state.email ? state.email.e : undefined, consent: state.email ? state.email.c === true : undefined })
    }).then(function (d) {
      if (typeof d.credits === 'number') setCredits(d.credits, d.cost);
      if (!d.image) {
        track('generate_error', { status: d._status || 0, error: String(d.error || d.message || '').slice(0, 120), ms: Date.now() - t0 });
        home();
        setError(d._status === 401 ? T["wheelsup.viz.err_session"] : (d.message || T["wheelsup.viz.err_generic"]));
        return;
      }
      var bin = atob(d.image), arr = new Uint8Array(bin.length);
      for (var k = 0; k < bin.length; k++) arr[k] = bin.charCodeAt(k);
      if (state.resultUrl) URL.revokeObjectURL(state.resultUrl);
      state.resultUrl = URL.createObjectURL(new Blob([arr], { type: d.mimeType || 'image/png' }));
      track('generate_success', { ms: Date.now() - t0, credits: state.credits });
      var before = carMode ? state.resultUrl : state.car;
      showResult(before, state.resultUrl, (d.mimeType || '').indexOf('jpeg') > -1 ? 'jpg' : 'png');
      saveHistory(before, state.resultUrl);
    }).catch(function () {
      track('generate_error', { status: 0, error: 'network', ms: Date.now() - t0 });
      home();
      setError(T["wheelsup.viz.err_connection"]);
    }).then(function () {
      state.busy = false;
      state.timers.forEach(clearTimeout); state.timers = [];
    });
  }
  $('.wvp__generate').addEventListener('click', generate);
  $('.wvp__regen').addEventListener('click', function () {
    if (state.other) { state.other = null; return home(); }
    generate();
  });

  function showResult(before, after, ext, other) {
    state.other = other || null;
    state.cmpTracked = false;
    show('result');
    var single = before === after;
    $('.wvp__result').classList.toggle('is-single', single);
    $('.wvp__ai-note').hidden = !single; $('.wvp__cmp-hint').hidden = single;
    $('.wvp__res-car').hidden = !single; $('.wvp__res-pick').hidden = single;
    var cmp = $('.wvp__result-cmp');
    cmp.setImages(before, after); relabel(cmp);
    var dl = $('.wvp__download');
    dl.href = after;
    dl.download = 'vizualizace-' + (other ? other.t : root.dataset.title).replace(/[^\w-]+/g, '-').toLowerCase() + '.' + (ext || 'jpg');
    var add = $('.wvp__add'), go = $('.wvp__goto'), qty = $('.wvp__qty-row');
    var foreign = other && other.u && other.u !== root.dataset.url;
    add.hidden = !!foreign; qty.hidden = !!foreign; go.hidden = !foreign;
    if (foreign) { go.href = other.u; setLabel(go, T["wheelsup.viz.show_x"] + ' ' + other.t); }
    renderTotal();
  }

  // full screen
  $('.wvp__full').addEventListener('click', function () { $('.wvp__stage').classList.toggle('is-full'); track('fullscreen'); });
  $('.wvp__download').addEventListener('click', function () { track('download'); });
  $('.wvp__result-cmp').addEventListener('pointerdown', function () { if (!state.cmpTracked) { state.cmpTracked = true; track('compare'); } });
  $('.wvp__goto').addEventListener('click', function () { track('goto_product', { target: state.other && state.other.u }); });

  // quantity and cart
  $('.wvp__qty-minus').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); renderTotal(); });
  $('.wvp__qty-plus').addEventListener('click', function () { state.qty = state.qty + 1; renderTotal(); });
  $('.wvp__add').addEventListener('click', function () {
    var selA = currentSelection();
    track('add_to_cart', { quantity: state.qty, price: selA.price / 100, value: selA.price * state.qty / 100, currency: root.dataset.currency, from_history: !!state.other });
    var form = productForm();
    var btn = form && (form.querySelector('[type="submit"][name="add"]') || form.querySelector('.product-form__add-button') || form.querySelector('[type="submit"]'));
    var qtyInput = form && form.querySelector('[name="quantity"]');
    if (btn) {
      if (qtyInput) { qtyInput.value = state.qty; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
      closeDialog();
      btn.click();
      return;
    }
    var fd = new FormData(); fd.append('id', currentVariantId()); fd.append('quantity', String(state.qty));
    fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      setLabel($('.wvp__add'), '✓ ' + T["wheelsup.viz.added"]);
      toast(state.qty + ' ' + T["wheelsup.viz.pcs_added"]);
    }).catch(function () { setError(T["wheelsup.viz.err_cart"]); });
  });

  // credit packs
  $$('.wvp__pack').forEach(function (p) {
    p.addEventListener('click', function () {
      $$('.wvp__pack').forEach(function (x) { x.classList.toggle('is-on', x === p); x.setAttribute('aria-checked', x === p ? 'true' : 'false'); });
      var t = $('.wvp__topup'); if (t) t.dataset.variant = p.dataset.variant;
      track('pack_select', { pack_variant: p.dataset.variant, pack_price: p.dataset.price });
      $('.wvp__topup-price').textContent = p.dataset.price;
    });
  });
  var topup = $('.wvp__topup');
  if (topup) topup.addEventListener('click', function () {
    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var topupText = topup.querySelector('.btn-text') || topup, label = topupText.innerHTML;
    track('topup', { pack_variant: topup.dataset.variant, pack_price: $('.wvp__topup-price').textContent });
    topup.disabled = true; topupText.textContent = T["wheelsup.viz.redirecting"];
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(topup.dataset.variant), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = shopRoot + 'checkout';
    }).catch(function () {
      topup.disabled = false; topupText.innerHTML = label;
      setError(T["wheelsup.viz.err_topup"]);
    });
  });

  // history (only in this browser)
  function readHistory() { try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch (e) { return []; } }
  function saveHistory(before, after) {
    Promise.all([shrink(before, 640, 0.7), shrink(after, 640, 0.7)]).then(function (r) {
      var list = readHistory();
      list.unshift({ t: root.dataset.title, u: root.dataset.url, d: Date.now(), b: r[0].data, a: r[1].data });
      list = list.slice(0, 6);
      while (list.length) {
        try { localStorage.setItem(HISTORY_KEY, JSON.stringify(list)); break; } catch (e) { list.pop(); }
      }
    }).catch(function () {});
  }
  function fmtDate(ts) {
    try { return new Date(ts).toLocaleString('cs-CZ', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; }
  }
  $$('.wvp__history-btn').forEach(function (hb) {
    hb.addEventListener('click', function () {
      if (state.screen !== 'history') state.prev = state.screen;
      var grid = $('.wvp__history-grid'), list = readHistory();
      track('history', { items: list.length });
      grid.innerHTML = '';
      list.forEach(function (h) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'wvp__history-item';
        var img = document.createElement('img'); img.src = h.a; img.alt = h.t; img.width = 320; img.height = 240;
        var name = document.createElement('strong'); name.textContent = h.t;
        var when = document.createElement('span'); when.textContent = fmtDate(h.d);
        b.appendChild(img); b.appendChild(name); b.appendChild(when);
        b.addEventListener('click', function () { showResult(h.b, h.a, 'jpg', h); });
        grid.appendChild(b);
      });
      $('.wvp__history-empty').hidden = list.length > 0;
      show('history');
    });
  });
  $('.wvp__back').addEventListener('click', function () {
    if (state.prev === 'result' && state.resultUrl && !state.other) return showResult(state.car, state.resultUrl);
    if (state.prev && state.prev !== 'history' && state.prev !== 'generating') return show(state.prev);
    home();
  });
})();
